module.exports = __webpack_public_path__ + "img/4.7a627775.jpg";